<template>
    <Breadcrumbs main="Form Widgets" title="Typeahead" />
    <div class="container-fluid">
        <div class="alert txt-primary alert-light-primary alert-dismissible fade show" role="alert"><i
                data-feather="alert-triangle"></i>
            <p>This is the Typeahead page where <strong>jQuery </strong> was utilised.</p>
            <button class="btn-close" type="button" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
        <div class="typeahead typeahead-wrapper">
            <div class="row">
                <basicTypeahead />
                <prefetchTypeahead />
                <bloodhoundTyeahead />
                <remoteTypeahead />
                <customTemplates />
                <multipleSections />
                <scrollableMenu />
                <rtlSupport />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const basicTypeahead = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/basicTypeahead.vue"))
const prefetchTypeahead = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/prefetchTypeahead.vue"))
const bloodhoundTyeahead = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/bloodhoundTyeahead.vue"))
const remoteTypeahead = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/remoteTypeahead.vue"))
const customTemplates = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/customTemplates.vue"))
const multipleSections = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/multipleSections.vue"))
const scrollableMenu = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/scrollableMenu.vue"))
const rtlSupport = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/rtlSupport.vue"))
</script>